const fieldsForm = {
  NomeExperiencia: 'Nome da Experiência',
  SegmentosTuristicos: 'Segmentos Turísticos',
  ItensTuristicos: 'Itens Turísticos',
  FrequenciaExperiencia: 'Frequência da Experiência',
  AdequadaLGBT: 'Experiência adequada a LGBT',
  AdequadaAcessibilidade: 'Experiência adequada a pessoas com deficiência ou mobilidade reduzida',
  AdequadaIdoso: 'Experîencia adequada a pessoas de idade +60',
  AdequadaCrianca: 'Experiência adequada a crianças e jovens',
  RoteiroPertencente: 'Experiência pertence a algum roteiro',
  RecebeEstrangeiro: 'Experiência recebe estrangeiros',
  Idiomas: 'Idiomas',
  ContratarAtendimentoIdioma: 'Disponibilidade de contratar algum profissional especializado',
  ExemploAtendimentoOutroIdioma: 'Exemplos de como a experiência é oferecida em outros idiomas',
  TipoExperiencia: 'Experiência sustentável ou responsável',
  DesenvolvimentoSustentavel: 'Objetivos de Desenvolvimento Sustentável',
  Sustentabilidade: 'Links/exemplos de sustentabilidade na experiência',
  ExperienciaInternacional: 'Experiência promovida internacionalmente',
  ComercioInternacional: 'Possui uma comercialização internacional',
  AutorizacaoImagem: 'Autorização de uso de imagem',
  Premiacao: 'Certificação da experiência',
  city: 'Cidade',
  country: 'País',
  state: 'Estado',
  managerName: 'Nome do Responsável',
  name: 'Nome da Empresa',
  type: 'Ramo de Atuação',
  state: 'Estado',
  city: 'Cidade',
  country: 'País',
  cnpj: 'CNPJ',
  typeOther: 'Outro Ramo de Atuação'
};

export function checkFields(obj, fields, setErrorMessage, setConfirmPopup) {
  try {
    // Checking if all required field aren't empty
    fields.forEach((f) => {
      if (!obj[f] || textIsEmpty(obj[f]) || objetcIsEmpty(obj[f]) || languageField(obj[f], f))
        throw new Error(`Preencha todos os campos obrigatórios. Campo: ${fieldsForm[f]}`);
    });
    
    setErrorMessage('');
    setConfirmPopup(true);
  } catch (error) {
    setErrorMessage(error.message);
  }
}

function objetcIsEmpty(obj) {
  if (typeof obj !== 'object') return false;

  const fields = Object.keys(obj);

  return fields.length === 0;
}

function textIsEmpty(text) {
  if (typeof text !== 'string') return false;

  return text === '';
}

function languageField(obj, field) {
  if (field !== 'Idiomas') return false;

  const fields = Object.keys(obj);

  return fields.length !== 5;
}